<div class="flex flex-col gap-2 bg-neutral-100 p-10">
  <div class="flex items-center justify-between">
    <h3>
      {{ "Груповані призначення" }}
    </h3>
    <button mat-dialog-close>
      <mat-icon
        aria-hidden="true"
        aria-label="Close icon"
        fontIcon="close"
      ></mat-icon>
    </button>
  </div>

  <div class="flex flex-col gap-2">
    <span class="mb-2">{{ "Виконано " + prescription().used + " з " + prescription().count }}</span>
    <div class="grid grid-cols-9 items-center gap-2 text-sm text-gray-2">
      <span class="col-span-4">{{ "Назва послуги" }}</span>
      <span class="col-span-2">{{ "Статус" }}</span>
      <span class="col-span-2">{{ "Коли виконана" }}</span>
    </div>
    <div class="max-h-[550px] overflow-y-auto overflow-x-hidden">
      @for (planning of prescriptionPlannings(); track $index) {
        <div class="mb-2 flex flex-col gap-2 rounded-md bg-neutral-50 px-4 py-3">
          <div class="grid grid-cols-9 items-center gap-2">
            <span class="col-span-4 font-semibold"> {{ prescription().name }} </span>
            <div class="col-span-2">
              <shared-status
                [statusValue]="planning.planningStatus"
                [statusMessage]="'status.prescription.planning.' + planning.planningStatus | translate"
              ></shared-status>
            </div>
            <span class="col-span-2 cursor-pointer">
              @if (planning.planningStatus === planningStatus.Completed) {
                {{ formatDate(planning.dateEnd, true) }}
              }
            </span>
            <button
              matSuffix
              mat-icon-button
              class="justify-self-end"
              type="button"
              aria-label="Clear"
              (click)="togglePlannedDetails($index)"
            >
              <mat-icon [fontIcon]="expandedDetails().has($index) ? 'expand_less' : 'expand_more'"></mat-icon>
            </button>
          </div>
          @if (expandedDetails().has($index)) {
            <div class="border-b-2 border-dashed border-gray-3"></div>
            <div class="flex flex-col text-sm">
              <div class="flex justify-between">
                <div class="flex items-center">
                  <span class="w-[90px] text-gray-2">{{ "Тип" }}</span>
                  <span>{{ "medicalServices.prescriptionTypes." + prescription().type | translate }}</span>
                </div>
                @if (
                  planning.planningStatus === planningStatus.Planned &&
                  prescription().type !== prescriptionTypes.LaboratoryService &&
                  prescription().type !== prescriptionTypes.Drugs
                ) {
                  <div class="flex cursor-pointer gap-2">
                    <mat-icon (click)="cancelAppointment(planning.id)">delete</mat-icon>
                  </div>
                }
              </div>

              <div class="flex items-center">
                <span class="w-[90px] text-gray-2">{{ "Назва" }}</span>
                <span>{{ prescription().name }}</span>
              </div>

              @if (planning.doctorName) {
                <div class="flex items-center">
                  <span class="w-[90px] text-gray-2">{{ "ПІБ лікаря" }}</span>
                  <span>{{ planning.doctorName }}</span>
                </div>
              }

              @if (planning.dateStart) {
                <div class="flex items-center">
                  <span class="w-[90px] text-gray-2">{{ "Дата і час" }}</span>
                  <span>{{ formatDate(planning.dateStart, true) }}</span>
                </div>
              }

              <!-- TODO: uncomment adjust and reuse when correct integration types will be added-->
              <!-- @if (planning.integrationType) {-->
              <!-- <div class="flex items-center">-->
              <!--    <span class="w-[90px] text-gray-2">{{ "Партнер" }}</span>-->
              <!--    <span>{{ planning.integrationType }}</span>-->
              <!-- </div>-->
              <!-- }-->

              @if (planning.location) {
                <div class="flex items-center">
                  <span class="w-[90px] text-gray-2">{{ "Адреса" }}</span>
                  <span class="text-blue-primary underline">{{ planning.location }}</span>
                </div>

                <div class="flex items-center">
                  <span class="w-[90px] text-gray-2"></span>
                  <span class="text-blue-primary underline">{{ planning.partnerName || ("appointments.descriptions.partnerNameNotSpecified" | translate) }}</span>
                </div>
              }

              @if ((prescription().type === prescriptionTypes.LaboratoryService || prescription().type === prescriptionTypes.Drugs) && planning.orderNumber) {
                <div class="flex items-center">
                  <span class="w-[90px] text-gray-2">{{ "Номер замовлення" }}</span>
                  <span>{{ planning.orderNumber }}</span>
                </div>
              }
            </div>
          }
        </div>
      }

      @if (prescriptionPlannings().length < prescription().count) {
        @for (item of [].constructor(prescription().count - prescriptionPlannings().length); track item) {
          <div class="mb-2 flex flex-col gap-2 rounded-md bg-neutral-50 px-4 py-3">
            <div class="grid grid-cols-9 items-center gap-2">
              <span class="col-span-4 flex flex-col font-semibold">
                {{ prescription().name }}
                <span class="text-sm font-thin text-gray-2">{{ "Рекомендовано по " + formatDate(prescription().endDate) }}</span>
              </span>
              <div class="col-span-2">
                <shared-status
                  [statusValue]="planningStatus.NotPlanned"
                  [statusMessage]="'status.prescription.planning.' + planningStatus.NotPlanned | translate"
                ></shared-status>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>

  <div class="mt-5 flex justify-end">
    <button
      class="btn btn-primary"
      mat-dialog-close
    >
      {{ "buttons.close" | translate }}
    </button>
  </div>
</div>
